import React from 'react';
import './Evaluaciones.css';

// Confirmación con el estilo de las evaluaciones (no usa window.confirm).
const EvaluacionesConfirm = ({ title, children, confirmLabel = 'Confirmar', danger = false, busy = false, onConfirm, onCancel }) => (
  <div className="ev-overlay ev-overlay-top" onMouseDown={busy ? undefined : onCancel}>
    <div className="ev-confirm" role="dialog" aria-modal="true" onMouseDown={(event) => event.stopPropagation()}>
      <h4>{title}</h4>
      <div className="ev-confirm-body">{children}</div>
      <div className="ev-confirm-actions">
        <button type="button" className="ev-btn ev-btn-secondary" onClick={onCancel} disabled={busy}>Cancelar</button>
        <button type="button" className={`ev-btn ${danger ? 'ev-btn-danger' : 'ev-btn-primary'}`} onClick={onConfirm} disabled={busy}>
          {busy && <i className="fas fa-spinner fa-spin" aria-hidden="true" />}
          {confirmLabel}
        </button>
      </div>
    </div>
  </div>
);

export default EvaluacionesConfirm;
